import React, { Component } from "react";

import "./Namecard.css";

export default class Namecard extends Component {
  render() {
    return (
      <div>
        <figure class="snip1559">
          <div class="profile-image">
            <img
              src="https://estacionpacifico.com/wp-content/uploads/2018/05/2015-10-06-FB-person.png"
              alt="profile-sample2"
            />
          </div>
          <figcaption>
            <h3>Bella Bates</h3>
            <h5>USC</h5>
            <p>
              A passionate thinker with a penchant for languages and new
              cultures.
            </p>
            <div class="icons">
              <a href="#">
                <i class="ion-social-reddit" />
              </a>
              <a href="#">
                {" "}
                <i class="ion-social-twitter" />
              </a>
              <a href="#">
                {" "}
                <i class="ion-social-vimeo" />
              </a>
            </div>
          </figcaption>
        </figure>
      </div>
    );
  }
}
